<script setup>
import { storeToRefs } from "pinia";
import useCotizacionEstandarKeyMetricsStore from "@/store/cotizaciones/estandar/key-metrics";
import useCotizacionEstandarSourcesStore from "@/store/cotizaciones/estandar/sources";
const { keyMetrics } = storeToRefs(useCotizacionEstandarKeyMetricsStore());
const { netVat } = storeToRefs(useCotizacionEstandarSourcesStore());
</script>

<template>
  <section>
    <div class="table-responsive">
      <table
        class="table table-striped table-bordered table-hover table-xs text-xs"
      >
        <tbody>
          <tr>
            <th>LTV: Facility Draw / Equip</th>
            <td>104.40%</td>
          </tr>
          <tr>
            <th>LTV: Facility Draw / (Equip + VAT)</th>
            <td>104.40%</td>
          </tr>
          <tr>
            <th>IRR (Gross)</th>
            <td>104.40%</td>
          </tr>
          <tr>
            <th>Monthly Payment</th>
            <td>${{ keyMetrics.monthlyPayment }}</td>
          </tr>
          <tr>
            <th>Tot Initial Servicer CF w/o VAT</th>
            <td>104.40%</td>
          </tr>
          <tr>
            <th>Lease Principal Amount</th>
            <td>${{ keyMetrics.leasePrincipalAmount }}</td>
          </tr>
          <tr>
            <th>Net VAT</th>
            <td>{{ netVat }}%</td>
          </tr>
          <tr>
            <th>Excess CF</th>
            <td>104.40%</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>
